import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'

import type {CodeViewRouteComponents} from './create-code-view-routes'

export const lazyCodeViewRouteComponents: CodeViewRouteComponents = {
  CodeViewBlameEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewBlameEntrypoint}
    }),
  ),
  CodeViewBlobEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewBlobEntrypoint}
    }),
  ),
  CodeViewBlobLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewBlobLayout}
    }),
  ),
  CodeViewBlobLayoutErrorBoundary: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewBlobLayoutErrorBoundary}
    }),
  ),
  CodeViewDeleteEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewDeleteEntrypoint}
    }),
  ),
  CodeViewEditEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewEditEntrypoint}
    }),
  ),
  CodeViewFileTreeLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewFileTreeLayout}
    }),
  ),
  CodeViewLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewLayout}
    }),
  ),
  CodeViewNewEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewNewEntrypoint}
    }),
  ),
  CodeViewRepoEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewRepoEntrypoint}
    }),
  ),
  CodeViewTreeDeleteEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewTreeDeleteEntrypoint}
    }),
  ),
  CodeViewTreeEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewTreeEntrypoint}
    }),
  ),
  CodeViewTreeErrorBoundary: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CodeViewTreeErrorBoundary}
    }),
  ),
}
